// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"aK-z","carouselContainer":"bK-z"};